import React from 'react';
import { MapPin, Clock, Phone, Mail, Coffee } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useOpeningHours } from '../contexts/OpeningHoursContext';
import { legalInfo } from '../utils/legal';
import { formatOpeningHours } from '../utils/openingHours';

const Footer: React.FC = () => {
  const { openingHours, loading } = useOpeningHours();
  
  return (
    <footer className="bg-black text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start space-x-2 mb-4">
              <img src="/logo.png" alt="Kiss Coffee Logo" className="h-8 w-8 object-contain" />
              <span className="text-2xl font-bold">Kiss Coffee Minehead</span>
            </div>
            <p className="text-gray-300 mb-4">
              Serving the finest coffee and delicious food in the heart of Minehead.
            </p>
          </div>

          {/* Contact Info */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-center justify-center md:justify-start space-x-3">
                <MapPin className="h-5 w-5 text-red-500" />
                <span>16 Friday Street, Minehead, TA24 5UA</span>
              </div>
              <div className="flex items-center justify-center md:justify-start space-x-3">
                <Phone className="h-5 w-5 text-red-500" />
                <span>07447786761</span>
              </div>
              <Link to="/contact" className="flex items-center justify-center md:justify-start space-x-3 hover:underline">
                <Mail className="h-5 w-5 text-red-500" />
                <span>Contact form</span>
              </Link>
            </div>
          </div>

          {/* Opening Hours */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-semibold mb-4">Opening Hours</h3>
            <div className="space-y-2">
              <div className="flex items-center justify-center md:justify-start space-x-3">
                <Clock className="h-5 w-5 text-red-500" />
                <div>
                  {loading ? (
                    <div>Loading hours...</div>
                  ) : (
                    formatOpeningHours(openingHours).map(({ day, hours }) => (
                      <div key={day}>{day}: {hours}</div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <div className="flex flex-col items-center gap-2 text-gray-400 text-sm">
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
              <Link to="/privacy-policy" className="hover:underline">Privacy</Link>
              <Link to="/cookie-policy" className="hover:underline">Cookies</Link>
              <Link to="/cookie-settings" className="hover:underline">Cookie Settings</Link>
              <Link to="/terms" className="hover:underline">Terms of Use</Link>
              <Link to="/terms-of-sale" className="hover:underline">Terms of Sale</Link>
              <Link to="/delivery-and-refunds" className="hover:underline">Delivery & Refunds</Link>
              <Link to="/accessibility" className="hover:underline">Accessibility</Link>
              <Link to="/allergens" className="hover:underline">Allergens</Link>
            </div>
            <div>
              © {new Date().getFullYear()} {legalInfo.tradingName || legalInfo.legalName}. All rights reserved.
            </div>
            <div className="text-xs text-gray-500">
              {legalInfo.legalName} {legalInfo.registeredIn ? `registered in ${legalInfo.registeredIn}` : ''}{legalInfo.companyNumber ? `, company no. ${legalInfo.companyNumber}` : ''}{legalInfo.vatNumber ? `, VAT no. ${legalInfo.vatNumber}` : ''}.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

